import React from 'react';
import { useNavigate } from 'react-router-dom';
import Plantafel from '../../assets/pictures/Plantafel.svg';
import Excel from '../../assets/pictures/Excel Import Gross.svg';

const cards = [
    {
        name: 'Plantafel',
        path: '/plantafel',
        image: Plantafel,
        description: 'Hier können Sie zur Plantafel wechseln, um die Planung zu starten.',
    },
    {
        name: 'Import',
        path: '/eventImport',
        image: Excel,
        description: 'Hier können Sie Events aus Ihrem Emma-Export importieren, bearbeiten und anschließend im System anlegen.',
    },
];

export default function EventmatchingSelection() {
    const navigate = useNavigate();

    return (
        <main className="w-full h-full px-4 py-4">
            <div className="flex w-full h-full gap-4">
                {cards.map(card => (
                    <div
                        key={card.name}
                        onClick={() => navigate(card.path)}
                        className="group flex-1 h-full relative cursor-pointer overflow-hidden rounded-2xl shadow-lg transition-all"
                    >
                        {/* Background image */}
                        <div
                            className="absolute inset-0 z-0 bg-cover bg-center transition-all duration-500 group-hover:blur-md group-hover:grayscale group-hover:scale-105"
                            style={{ backgroundImage: `url("${card.image}")` }}
                        />
                        {/* Dark overlay */}
                        <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10 pointer-events-none" />
                        {/* Text */}
                        <div className="absolute inset-0 z-20 flex flex-col items-center justify-start pt-40 text-center text-black px-4">
                            <h2 className="text-4xl font-bold drop-shadow">{card.name}</h2>
                            <p className="text-lg mt-4 hidden group-hover:block transition-all duration-300">
                                {card.description}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </main>
    );
}
